module.exports = __webpack_public_path__ + "img/treppenaufgang.8a8b172b.webp";